'use strict';

var util = angular.module('gymsystem.util');

util.directive('unconfirmedresourcebookings', ['$rootScope', '$controller', 'util', function($rootScope, $controller, util) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            const config = {
                getFilterClass: function() {
                    return 'hidden';
                },
                saveFilter: null,
                api: {
                    args: {
                        category_id: $scope.settings?.category_id,
                        resource_id: $scope.settings?.only_show_mine ? [$rootScope.currentStaff.id] : $scope.settings?.resource_id
                    }
                }
            };

            $rootScope.waitFor(['resourcebookingcategories']).then(function() {
                $controller('ResourceBookingUnconfirmedCtrl', {$scope: $scope, options: {config}});
            });
        }
    };
}]);
